export default __webpack_public_path__ + "static/media/bg1.7028ed12.jpg";